'use client'

import CardPlacingOrder from '@/entities/cart-page/CardPlacingOrder'
import { useGetCartInfoQuery } from '@/shared/api-rtk/api-list/cartApi'
import {
    changeCurrentStep,
    changePaymentMethodValue,
    changeShippingMethodValue,
    updateShippingMethod,
} from '@/shared/store/slice/cartSlice'
import { useEffect, useRef, useState } from 'react'
import { Button, Form, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import './ShippingMethods.css'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { API_URL } from '@/shared/constants/linksApi.js'

function termsToSting(terms) {
    var plural = false
    if (typeof terms !== 'number' && terms.length > 1) {
        var plural = terms.split('-')
        terms = parseInt(plural[plural.length - 1])
    }

    var res = 'Срок доставки: '
    if (plural) {
        res += 'от ' + plural[0] + ' до '
    }
    function num_word(value, words, rPad = false) {
        value = Math.abs(value) % 100
        var num = value % 10
        if (value > 10 && value < 20) return words[2]
        if (num > 1 && num < 5) return rPad ? words[2] : words[1]
        if (num == 1) return rPad ? words[1] : words[0]
        return words[2]
    }

    return (
        res +
        terms.toString() +
        ' ' +
        num_word(terms, ['день', 'дня', 'дней'], Boolean(plural))
    )
}

export const ShippingMethods = ({userInfo}) => {
    const {
        shippingMethods: data,
        areaType,
        currentStep: step,
        areaZoneId,
        shippingMethodValue: value,
        cdekEnabled,
        yandexEnabled,
    } = useSelector((state) => state.cartActions)

    const [cdekPvzData, setCdekPvzData] = useState(null)
    const [cdekReady, setCdekReady] = useState(false)
    const [errorCheckedCdek, setErrorCheckedCdek] = useState(false)

    const [yandexPvzData, setYandexPvzData] = useState(null)
    const [errorCheckedYandex, setErrorCheckedYandex] = useState(false)
    const [yandexWidgetOpen, setYandexWidgetOpen] = useState(false)
    const [yandexWidgetInitialized, setYandexWidgetInitialized] = useState(false)

    // Состояния для поиска города
    const [citySearch, setCitySearch] = useState('')
    const [citySuggestions, setCitySuggestions] = useState([])
    const [selectedCity, setSelectedCity] = useState(null)
    const [isCitySearching, setIsCitySearching] = useState(false)
    const [showCitySelector, setShowCitySelector] = useState(false)
    const [isAutoCity, setIsAutoCity] = useState(false)
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false)

    const dispatch = useDispatch()
    const { refetch } = useGetCartInfoQuery()
    const widget = useRef(null)

    // Функция для определения города по areaType
    const getCityByAreaType = (areaType) => {
        if (!areaType) return null
        
        if (areaType === 'msk.inside-mkad' || areaType === 'msk.outside-mkad' || areaType.includes('moscow')) {
            return { address: 'Москва', geo_id: '213' }
        }
        if (areaType === 'spb.inside-kad' || areaType === 'spb.outside-kad' || areaType.includes('saint-petersburg')) {
            return { address: 'Санкт-Петербург', geo_id: '2' }
        }
        return null
    }

    // Сброс всех данных при смене города
    useEffect(() => {
        setCdekPvzData(null)
        setYandexPvzData(null)
        setErrorCheckedCdek(false)
        setErrorCheckedYandex(false)
        setYandexWidgetInitialized(false)
        setYandexWidgetOpen(false)
        
        if (areaType === 'another') {
            setSelectedCity(null)
            setCitySearch('')
            setIsAutoCity(false)
            setShowCitySelector(false)
            setCitySuggestions([])
        }
        
        if (widget.current) {
            try {
                widget.current.close()
            } catch (e) {}
            widget.current = null
        }
        setCdekReady(false)
        
        const container = document.getElementById('yandex-delivery-widget')
        if (container) {
            container.innerHTML = ''
        }
        
        dispatch(changeShippingMethodValue(null))
        dispatch(changePaymentMethodValue(null))
        setHasLoadedOnce(false)
        
    }, [areaType, dispatch])

    // Автоматический выбор города ТОЛЬКО при первой загрузке
    useEffect(() => {
        if (areaType && areaType !== 'another' && !hasLoadedOnce) {
            const autoCity = getCityByAreaType(areaType)
            if (autoCity) {
                setSelectedCity(autoCity)
                setCitySearch(autoCity.address)
                setIsAutoCity(true)
            }
            setHasLoadedOnce(true)
        }
    }, [areaType, hasLoadedOnce])

    // Функция выбора города (ручной выбор)
    const selectCity = (city) => {
        console.log('Выбран город:', city)
        
        setSelectedCity(city)
        setCitySearch(city.address)
        setCitySuggestions([])
        setYandexPvzData(null)
        setErrorCheckedYandex(false)
        setShowCitySelector(false)
        setYandexWidgetInitialized(false)
        setIsAutoCity(false)
    }

    // СДЭК виджет
    const widgetIntegration = () => {
        widget.current = new window.CDEKWidget({
            apiKey: '84ef9355-9781-4b37-8510-16851be9f55a',
            canChoose: true,
            servicePath: `${API_URL}/cms/service.php`,
            hideFilters: {
                have_cashless: false,
                have_cash: false,
                is_dressing_room: false,
                type: false,
            },
            hideDeliveryOptions: {
                office: false,
                door: true,
            },
            debug: true,
            goods: [
                {
                    width: 10,
                    height: 10,
                    length: 10,
                    weight: 10,
                },
            ],
            fixBounds: null,
            defaultLocation: 'Москва',
            lang: 'rus',
            currency: 'RUB',
            forceFilters: {
                type: 'PVZ',
            },
            popup: true,
            tariffs: {
                office: [],
                door: [],
            },
            onReady() {
                setCdekReady(true)
            },
            onCalculate() {},
            onChoose(delivery, price, address) {
                setErrorCheckedCdek(false)
                onPvzChoose(address)
            },
        })
    }

    function onPvzChoose(data) {
        dispatch(changeShippingMethodValue('cdek.cdek'))
        const cdeckData = {
            id: data.code,
            cityCode: data.city_code,
            city: data.city,
            street: data.address,
            note: data.name,
            cdek_terms: data.work_time,
        }
        setCdekPvzData(cdeckData)
        dispatch(changePaymentMethodValue(null))
        dispatch(changeCurrentStep(2))
        widget.current.close()
    }

    const hanldeChange = (e) => {
        setErrorCheckedCdek(false)
        setCdekPvzData(null)
        dispatch(changePaymentMethodValue(null))
        dispatch(changeCurrentStep(2))
        dispatch(changeShippingMethodValue(e.target.value))
    }

    const onCdekSelect = async (e) => {
        if (!widget.current) {
            await widgetIntegration()
            await widget.current.open()
        } else {
            widget.current.open()
        }
        hanldeChange(e)
    }

    // Функция поиска города через API Яндекс
    const searchCity = async (query) => {
        if (!query || query.length < 2) {
            setCitySuggestions([])
            return
        }

        setIsCitySearching(true)

        try {
            const response = await fetch(
                `${API_URL}/cms/index.php?route=d_quickcheckout/yandex/detectLocation`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ location: query }),
                }
            )

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const data = await response.json()

            if (data && data.variants && Array.isArray(data.variants)) {
                setCitySuggestions(data.variants)
            } else if (data && data.data && Array.isArray(data.data)) {
                setCitySuggestions(data.data)
            } else {
                setCitySuggestions([])
            }
        } catch (error) {
            console.error('Ошибка поиска города:', error)
            setCitySuggestions([])
        } finally {
            setIsCitySearching(false)
        }
    }

    // Инициализация виджета Яндекс Доставки
    const initYandexWidget = (city) => {
        if (!window.YaDelivery) {
            console.warn('YaDelivery not loaded yet, waiting...')
            const checkYaDelivery = setInterval(() => {
                if (window.YaDelivery) {
                    clearInterval(checkYaDelivery)
                    createWidget(city)
                }
            }, 200)
            setTimeout(() => {
                clearInterval(checkYaDelivery)
                if (!window.YaDelivery) {
                    TOAST_ERROR('Виджет Яндекс Доставки не загружен. Попробуйте обновить страницу.')
                }
            }, 5000)
            return
        }

        createWidget(city)
    }

    // Создание виджета
    const createWidget = (city) => {
        try {
            const container = document.getElementById('yandex-delivery-widget')
            if (!container) {
                console.error('Container not found, retrying...')
                setTimeout(() => {
                    createWidget(city)
                }, 300)
                return
            }

            console.log('Container found, creating widget for city:', city.address)

            container.innerHTML = ''

            window.YaDelivery.createWidget({
                containerId: 'yandex-delivery-widget',
                params: {
                    city: city.address,
                    size: {
                        height: '100%',
                        width: '100%'
                    },
                    delivery_price: 'от 0',
                    delivery_term: 'от 1 дня',
                    show_select_button: true,
                    filter: {
                        type: ['pickup_point', 'terminal'],
                        is_yandex_branded: false,
                        payment_methods: ['already_paid', 'card_on_receipt', 'postpay'],
                        payment_methods_filter: 'or'
                    }
                }
            })

            setYandexWidgetInitialized(true)
            console.log('Виджет Яндекс Доставки создан для города:', city.address)

        } catch (error) {
            console.error('Ошибка инициализации виджета Яндекс:', error)
            TOAST_ERROR('Ошибка загрузки виджета Яндекс Доставки')
        }
    }

    // Обработчик выбора ПВЗ
    const handlePointSelected = (event) => {
        const point = event.detail
        console.log('Выбран ПВЗ:', point)

        if (!point) return

        const yandexData = {
            // Сначала ищем platform_station_id (UUID), если нет — берем id как запасной вариант
            id: point.platform_station_id || point.station_id || point.id,
            name: point.name || 'ПВЗ',
            address: point.address?.full_address || 
                    `${point.address?.locality || ''} ${point.address?.street || ''} ${point.address?.house || ''}`.trim() || 
                    'Адрес не указан',
            comment: point.address?.comment || '',
            geo_id: point.address?.geoId || null,
            position: point.position || null,
        }

        setYandexPvzData(yandexData)
        closeYandexWidget()
        setErrorCheckedYandex(false)
        dispatch(changePaymentMethodValue(null))
        dispatch(changeCurrentStep(2))
        
        if (value !== 'yandex.yandex') {
            dispatch(changeShippingMethodValue('yandex.yandex'))
        }

        TOAST_ERROR('Пункт выдачи выбран: ' + yandexData.name)
    }

    const closeYandexWidget = () => {
        setYandexWidgetOpen(false)
        document.body.style.overflow = 'auto'
    }

    const openYandexWidget = () => {
        if (selectedCity) {
            setYandexWidgetOpen(true)
            document.body.style.overflow = 'hidden'
            
            setTimeout(() => {
                initYandexWidget(selectedCity)
            }, 300)
            return
        }
        
        const autoCity = getCityByAreaType(areaType)
        if (autoCity) {
            setSelectedCity(autoCity)
            setCitySearch(autoCity.address)
            setIsAutoCity(true)
            setYandexWidgetOpen(true)
            document.body.style.overflow = 'hidden'
            
            setTimeout(() => {
                initYandexWidget(autoCity)
            }, 300)
            return
        }
        
        setShowCitySelector(true)
    }

    // Загрузка скрипта виджета Яндекс
    const loadYandexWidgetScript = () => {
        if (document.querySelector('script[src*="widget-pvz.dostavka.yandex.net"]')) {
            console.log('Скрипт виджета уже загружен')
            return
        }

        const script = document.createElement('script')
        script.src = 'https://widget-pvz.dostavka.yandex.net/widget.js?v=2'
        script.async = true
        
        script.onload = () => {
            console.log('Виджет Яндекс Доставки загружен (v2)')
        }
        
        script.onerror = () => {
            console.error('Ошибка загрузки виджета Яндекс')
            TOAST_ERROR('Ошибка загрузки виджета Яндекс Доставки')
        }
        
        document.head.appendChild(script)
    }

    // Обработчик для Яндекс Доставки
    const onYandexSelect = async (e) => {
        dispatch(changeShippingMethodValue('yandex.yandex'))
        dispatch(changePaymentMethodValue(null))
        dispatch(changeCurrentStep(2))
        setErrorCheckedYandex(false)
        
        openYandexWidget()
    }

    // Загружаем скрипт виджета при монтировании
    useEffect(() => {
        loadYandexWidgetScript()

        document.addEventListener('YaNddWidgetPointSelected', handlePointSelected)

        return () => {
            document.removeEventListener('YaNddWidgetPointSelected', handlePointSelected)
            document.body.style.overflow = 'auto'
        }
    }, [])

    useEffect(() => {
        return () => {
            if (widget.current) {
                try {
                    widget.current.close()
                } catch (e) {}
                widget.current = null
            }
        }
    }, [])

    const handleChangeStep = async (e) => {
        if (value == 'cdek.cdek' && !cdekPvzData) {
            setErrorCheckedCdek(true)
            return TOAST_ERROR('Вы не выбрали пункт выдачи')
        }
        if (value == 'yandex.yandex' && !yandexPvzData) {
            setErrorCheckedYandex(true)
            return TOAST_ERROR('Вы не выбрали пункт выдачи')
        }
        
        let body = { shipping_method: value, userInfo }
        if (value == 'cdek.cdek') {
            body = { ...body, ...cdekPvzData }
        }
        if (value == 'yandex.yandex') {
            body = {
                ...body,
                yandex_delivery: true,
                yandex_pvz_id: yandexPvzData?.id,
                yandex_pvz_name: yandexPvzData?.name,
                yandex_pvz_address: yandexPvzData?.address,
                yandex_pvz_comment: yandexPvzData?.comment,
                yandex_city: selectedCity?.address,
                yandex_geo_id: selectedCity?.geo_id,
                yandex_pvz_position: yandexPvzData?.position,
            }
        }
        await dispatch(updateShippingMethod(body))
        await refetch()
    }

    const changeCdekPvz = () => {
        if (widget.current) {
            widget.current.open()
        }
    }

    const changeYandexPvz = () => {
        openYandexWidget()
    }

    const resetCitySelection = () => {
        setSelectedCity(null)
        setCitySearch('')
        setCitySuggestions([])
        setYandexPvzData(null)
        setYandexWidgetInitialized(false)
        setIsAutoCity(false)
        closeYandexWidget()
        
        const container = document.getElementById('yandex-delivery-widget')
        if (container) {
            container.innerHTML = ''
        }
    }

    return (
        <>
            <CardPlacingOrder
                stepTitle={'Шаг 2: Способ доставки'}
                changeStep={handleChangeStep}
                className={step < 2 ? 'disabled-step' : ''}
                currentStep={step === 2}
                textButton={'Следующий шаг'}
                isValid={value}
            >
                <h3> Выберите подходящий способ доставки:</h3>
                
                {/* СДЭК */}
                {cdekEnabled && (
                    <div className="shipping-option">
                        <InputGroup onClick={changeCdekPvz} className="shipping-input-group">
                            <Form.Check
                                value={'cdek.cdek'}
                                id="cdek"
                                type={'radio'}
                                name="shippeng_method"
                                onChange={onCdekSelect}
                                checked={value === 'cdek.cdek'}
                                className="shipping-radio"
                            />
                            <label htmlFor="cdek" className="shipping-label">
                                <span className="shipping-title">Доставка СДЭК в ПВЗ по всей России</span>
                            </label>
                        </InputGroup>
                        {errorCheckedCdek && (
                            <span className="shipping-error">Выберите точку выдачи</span>
                        )}
                        {cdekPvzData && (
                            <div className="selected-pvz">
                                <div className="selected-pvz-info">
                                    <span className="pvz-address">{cdekPvzData.note}</span>
                                    <span className="pvz-details">{cdekPvzData.cdek_terms}</span>
                                </div>
                                <Button size="sm" onClick={changeCdekPvz} className="change-pvz-btn">
                                    изменить
                                </Button>
                            </div>
                        )}
                    </div>
                )}

                {/* Яндекс Доставка */}
                {yandexEnabled && (
                    <div className="shipping-option">
                        <InputGroup className="shipping-input-group">
                            <Form.Check
                                value={'yandex.yandex'}
                                id="yandex"
                                type={'radio'}
                                name="shippeng_method"
                                onChange={onYandexSelect}
                                checked={value === 'yandex.yandex'}
                                className="shipping-radio"
                            />
                            <label htmlFor="yandex" className="shipping-label">
                                <span className="shipping-title">Доставка Яндекс в ПВЗ по всей России</span>
                            </label>
                        </InputGroup>
                        {errorCheckedYandex && (
                            <span className="shipping-error">Выберите пункт выдачи</span>
                        )}
                        
                        {selectedCity && !yandexPvzData && value === 'yandex.yandex' && (
                            <div 
                                className="select-pvz-prompt"
                                onClick={() => {
                                    setSelectedCity(null)
                                    setCitySearch('')
                                    setCitySuggestions([])
                                    setShowCitySelector(true)
                                    setIsAutoCity(false)
                                    setYandexPvzData(null)
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <span>{selectedCity.address}</span>
                                <Button 
                                    size="sm" 
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        changeYandexPvz()
                                    }} 
                                    className="select-pvz-btn"
                                >
                                    выбрать ПВЗ
                                </Button>
                            </div>
                        )}

                        {yandexPvzData && selectedCity && (
                            <div className="selected-pvz">
                                <div className="selected-pvz-info">
                                    <span className="pvz-city"> {selectedCity.address}</span>
                                    <span className="pvz-name">{yandexPvzData.name}</span>
                                    <span className="pvz-address">{yandexPvzData.address}</span>
                                </div>
                                <Button size="sm" onClick={changeYandexPvz} className="change-pvz-btn">
                                    изменить
                                </Button>
                            </div>
                        )}
                    </div>
                )}

                {/* Выбор города для Яндекс */}
                {showCitySelector && (
                    <div className="city-selector">
                        <div className="city-selector-title">
                            Выберите город
                        </div>
                        <div className="city-selector-input-group">
                            <input
                                type="text"
                                placeholder="Введите название города..."
                                value={citySearch}
                                onChange={(e) => {
                                    setCitySearch(e.target.value)
                                    searchCity(e.target.value)
                                    if (isAutoCity) {
                                        setIsAutoCity(false)
                                        setSelectedCity(null)
                                    }
                                }}
                                className="city-search-input"
                            />
                            <button
                                onClick={() => searchCity(citySearch)}
                                className="city-search-btn"
                            >
                                Найти
                            </button>
                        </div>
                        
                        {isCitySearching && (
                            <div className="city-search-loading">
                                Поиск...
                            </div>
                        )}
                        
                        {citySuggestions.length > 0 && (
                            <div className="city-suggestions">
                                {citySuggestions.map((city, index) => (
                                    <div
                                        key={index}
                                        onClick={() => selectCity(city)}
                                        className="city-suggestion-item"
                                    >
                                        <div className="city-suggestion-name">{city.address}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                        
                        
                        <div className="city-selector-hint">
                            Введите город, где вы хотите получить заказ
                        </div>
                    </div>
                )}
            {areaType !== 'another' && (
                <div className="shipping-option">
                                <InputGroup>
                                    <Form.Check
                                        id="flat"
                                        value={'flat.flat'}
                                        type={'radio'}
                                        name="shippeng_method"
                                        onChange={hanldeChange}
                                        checked={value == 'flat.flat'}
                                        className="shipping-radio"
                                    />
                                    <label htmlFor="flat">
                                        <span>Доставка курьерской службой до двери</span>
                                    </label>
                                </InputGroup>
                                </div>
                            )}
                {/* Самовывоз */}
                {areaType === 'msk.inside-mkad' && (
                    <div className="shipping-option">
                        <InputGroup className="shipping-input-group">
                            <Form.Check
                                id="pickup"
                                value={'pickup.pickup'}
                                type={'radio'}
                                name="shippeng_method"
                                onChange={hanldeChange}
                                checked={value == 'pickup.pickup'}
                                className="shipping-radio"
                            />
                            <label htmlFor="pickup" className="shipping-label">
                                <span className="shipping-title">Самовывоз</span>
                            </label>
                        </InputGroup>
                    </div>
                )}
            </CardPlacingOrder>

            {/* Модальное окно для Яндекс Доставки */}
            {yandexWidgetOpen && (
                <div className="yandex-widget-overlay" onClick={(e) => {
                    if (e.target === e.currentTarget) closeYandexWidget()
                }}>
                    <div className="yandex-widget-modal">
                        <div className="yandex-widget-header">
                            <h3 className="yandex-widget-title">
                                Выбор пункта выдачи — {selectedCity?.address || 'Выберите город'}
                            </h3>
                            <button 
                                className="yandex-widget-close"
                                onClick={closeYandexWidget}
                            >
                                ✕
                            </button>
                        </div>
                        <div className="yandex-widget-body">
                            <div id="yandex-delivery-widget" className="yandex-delivery-container" />
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}